// extracted by mini-css-extract-plugin
module.exports = {"page":"Page3_page__19tcE","bg":"Page3_bg__36-nc","bg2":"Page3_bg2__3j1B_"};